"use client";

import { usePathname } from "next/navigation";
import Headline from "@/components/ui/Headline";
import Text from "@/components/ui/Text";
import Button from "@/components/ui/Button";

export default function NotFound() {

  const pathname = usePathname();
  const lang = pathname?.startsWith("/de") ? "de" : "en";

  const content = {
    de: {
      headline: "404 - Seite wurde nicht gefunden",
      message: "Ups! Es sieht so aus, als hättest du dich ins Leere verirrt. Die Seite, die du suchst, existiert nicht.",
      button: "Zurück zur Startseite",
      href: "/de"
    },
    en: {
      headline: "404 - Page Not Found",
      message: "Oops! It looks like you've ventured into the void. The page you are looking for does not exist.",
      button: "Return Home",
      href: "/en"
    }
  };

  const t = content[lang] || content.de;

  return (
    <div className="container min-h-screen flex flex-col items-center justify-center text-center py-23 md:py-31">
      <Headline
        className="mb-3 xl:mb-4"
        text={t.headline}
        level="h1"
      />
      <Text className="mb-6 md:mb-8 xl:mb-10">
        {t.message}
      </Text>
      <Button href={t.href}>
        {t.button}
      </Button>
    </div>
  );
}